import { useState } from "react";
import Flexbox from "./Flexbox";
import Spacebox from "./Spacebox";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ChevronLeft } from '@mui/icons-material'
import { isMobile } from "react-device-detect";

const Faq = () => {
    const questions = [
        {
            question: 'Is there a prepayment penalty?',
            answer: `No, there are no prepayment penalties. In fact, we offer discounts for early payoff, which can help you save on the total cost of funding.`,
            tag: 'Repayment'
        },
        {
            question: 'How much funding can I qualify for?',
            answer: `Businesses can qualify for up to $500,000 in funding, depending on factors like monthly revenue, time in business, and credit score. Our AI-powered system evaluates multiple data points to determine your maximum funding amount.`,
            tag: 'Eligibility'
        },
        {
            question: 'How quickly can I get funded?',
            answer: `Most approved businesses receive funding within 24-48 hours after completing their application. Our streamlined process and automated underwriting system allow for quick decisions and fast funding transfers.`,
            tag: 'Process'
        },
        {
            question: 'How does the repayment process work?',
            answer: `We offer flexible weekly repayment terms that align with your business's cash flow. Payments are automatically deducted, and you can choose terms ranging from 3 to 18 months.`,
            tag: 'Repayment'
        },
        {
            question: 'Are there any upfront fees?',
            answer: `No, there are no upfront fees. We believe in transparent pricing, and any fees associated with your funding will be clearly disclosed in your offer terms.`,
            tag: 'Fees'
        },
        {
            question: 'What can I use the funding for?',
            answer: `The funding can be used for any business purpose, including inventory, equipment, marketing, expansion, working capital, or refinancing existing debt.`,
            tag: 'Usage'
        },
        {
            question: 'Do you require collateral?',
            answer: `No, we don't require any collateral. Our funding is unsecured and based on your business's performance and potential.`,
            tag: 'Requirements'
        },
        {
            question: 'What documents do I need to apply?',
            answer: `You'll need: 3 months of business bank statements, valid ID, and basic business information. Additional documents may be requested based on your funding amount.`,
            tag: 'Process'
        },
        {
            question: 'Can I get approved with bad credit?',
            answer: `Yes, we work with all credit profiles. While we do check credit, our decision is based more heavily on your business's revenue and overall health.`,
            tag: 'Eligibility'
        },
    ]

    const [activeQuestions, setActiveQuestions] = useState(questions)

    const tags = ['All', 'Eligibility', 'Process', 'Fees', 'Usage', 'Requirements', 'Repayment']

    const [selectedTag, setSelectedTag] = useState('All')

    const changeQuestions = (tag) => {
        setSelectedTag(tag)
        
        if (tag === 'All')
            setActiveQuestions([...questions])
        else
            setActiveQuestions([...questions.filter((q) => q.tag === tag)])
    }

    return (
        <div className="faq" style={{width: '100%'}}>
            <Spacebox padding="20px" style={{width: 'calc(100% - 40px)'}}>
                <Flexbox className="hide-scrollbar" alignItems="center" style={{maxWidth: isMobile ? '300px' : '100%', overflowX: 'scroll'}}>
                    {tags.map((tag, index) => (
                        <div style={{ background: selectedTag === tag ? '#4A3FFF' : '#4A3FFF20', borderRadius: '100px', padding: '10px 20px', color: selectedTag === tag ? 'white' : '#4A3FFF', margin: '0px 5px', cursor: 'pointer' }} key={index} onClick={() => changeQuestions(tag)}>
                            {tag}
                        </div>
                    ))}
                </Flexbox>
            </Spacebox>
            {activeQuestions && (
                <div className="margin-auto" style={{ maxWidth: isMobile ? '100%' : '700px' }}>
                    {activeQuestions.map((q, i) => (
                        <Accordion key={i} className="cust-faq">
                            <AccordionSummary
                                expandIcon={<ChevronLeft style={{ transform: 'rotate(90deg)', color: 'var(--primary)', fontSize: '18px' }} />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <span style={{ fontSize: isMobile ? '18px' : '21px' }}>{q.question}</span>
                            </AccordionSummary>
                            <AccordionDetails>
                                <span className="content" style={{ opacity: .6 }}>
                                    {q.answer}
                                </span>
                                <Spacebox padding="5px" />
                                <div style={{ background: '#4A3FFF20', borderRadius: '100px', padding: '7px 15px', color: '#4A3FFF', display: 'inline-block' }}>
                                    <small>
                                        {q.tag}
                                    </small>
                                </div>
                                <Spacebox padding="5px" />
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Faq;